module.exports = __webpack_public_path__ + "static/media/icon_nav_support.75103574.svg";